import defaultState from "./state";

const globalReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'GLOBAL/CHANGE_GENERAL_DAYS':
      return Object.assign({}, state, {
        ...state,
        ENV: {
          ...state.ENV,
          REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: action.days,
        },
      });

    case "GLOBAL/CARGAR_TIPOS_UNIDAD": {
      return Object.assign({}, state, {
        loading: false,
        tiposUnidad: action.tiposUnidad,
      });
    }

    case "GLOBAL/CARGAR_TIPOS_PRESTACIONES": {
      return Object.assign({}, state, {
        loading: false,
        tiposPrestaciones: action.tiposPrestaciones,
      });
    }

    case "GLOBAL/CARGAR_TIPOS_PRESTACIONES_ISAPRE": {
      return Object.assign({}, state, {
        tiposPrestacionesIsapre: action.tiposPrestacionesIsapre,
      });
    }

    case "GLOBAL/CARGAR_ITEMS_IMED": {
      return Object.assign({}, state, {
        loading: false,
        itemsImed: action.itemsImed,
      });
    }

    case "GLOBAL/CARGAR_TIPOS_PROFESIONALES": {
      return Object.assign({}, state, {
        loading: false,
        tiposProfesionales: action.tiposProfesionales,
      });
    }

    case "GLOBAL/CARGAR_PERTENENCIA_FONASA": {
      return Object.assign({}, state, {
        loading: false,
        pertenenciasFonasa: action.pertenenciasFonasa
          .sort((a, b) => (a.Simbolo > b.Simbolo ? 1 : (a.Simbolo < b.Simbolo ? -1 : 0))),
      });
    }

    case "GLOBAL/CARGAR_ESTADOS_SOLICITUD": {
      return Object.assign({}, state, {
        loading: false,
        estadosSolicitud: action.estadosSolicitud,
      });
    }

    case "GLOBAL/CARGAR_TIPOS_SOLICITUD": {
      return Object.assign({}, state, {
        loading: false,
        tiposSolicitud: action.tiposSolicitud,
      });
    }

    case "GLOBAL/FILTRO_CARGAR_CENTROS_ATENCION": {
      const filtros = Object.assign({}, state.filtros_CAT, {
        centroAtencion: action.centrosAtencion[0].Secuencia,
        centrosAtencion: action.centrosAtencion,
      });
      return Object.assign({}, state, {
        filtros_CAT: filtros,
      });
    }

    case "GLOBAL/FILTRO_CARGAR_TIPOS_ARANCEL": {
      const filtros = Object.assign({}, state.filtros_CAT, {
        tipoArancel: action.tiposArancel[0].Rut,
        tiposArancel: action.tiposArancel,
      });
      return Object.assign({}, state, {
        filtros_CAT: filtros,
      });
    }

    case "GLOBAL/CARGAR_TIPOS_ARANCEL": {
      return Object.assign({}, state, {
        tiposArancel: action.tiposArancel,
      });
    }

    case "GLOBAL/FILTRO_CARGAR_TIPOS_PRESTACIONES": {
      const filtros = Object.assign({}, state.filtros_CAT, {
        tipoPrestacion: action.tiposPrestaciones[0].Id,
        tiposPrestaciones: action.tiposPrestaciones,
      });
      return Object.assign({}, state, {
        filtros_CAT: filtros,
      });
    }

    case "GLOBAL/FILTRO_CAMBIAR_CENTRO_ATENCION": {
      const filtros = Object.assign({}, state.filtros_CAT, {
        centroAtencion: action.centroAtencion,
      });
      return Object.assign({}, state, {
        filtros_CAT: filtros,
      });
    }

    case "GLOBAL/FILTRO_CAMBIAR_TIPO_ARANCEL": {
      const filtros = Object.assign({}, state.filtros_CAT, {
        tipoArancel: action.tipoArancel,
      });
      return Object.assign({}, state, {
        filtros_CAT: filtros,
      });
    }

    case "GLOBAL/FILTRO_CAMBIAR_TIPO_PRESTACION": {
      const filtros = Object.assign({}, state.filtros_CAT, {
        tipoPrestacion: action.tipoPrestacion,
      });
      return Object.assign({}, state, {
        filtros_CAT: filtros,
      });
    }

    case "GLOBAL/FILTRO_CAMBIAR_CODIGO_FONASA": {
      const filtros = Object.assign({}, state.filtros_CAT, {
        codFonasa: action.codFonasa,
      });
      return Object.assign({}, state, {
        filtros_CAT: filtros,
      });
    }

    case "GLOBAL/FILTRO_CAMBIAR_CODIGO_PRESTACION": {
      const filtros = Object.assign({}, state.filtros_CAT, {
        codPrestacion: action.codPrestacion,
      });
      return Object.assign({}, state, {
        filtros_CAT: filtros,
      });
    }

    case "GLOBAL/SET_VARIABLES_SESION": {
      return Object.assign({}, state, {
        rutInstitucion: action.sesion.rutInstitucion,
        rutPrestador: action.sesion.rutPrestador,
        rutUsuario: action.sesion.rutUsuario,
        isapre: action.sesion.isapre,
      });
    }

    case "GLOBAL/DIALOG_GENERIC": {
      const dialogGeneric = Object.assign({}, state.dialogGeneric, {
        open: action.accionModal,
        contenido: action.contenido,
      });
      return Object.assign({}, state, {
        dialogGeneric,
      });
    }

    case "GLOBAL/GUARDAR_TOKEN_ID": {
      return Object.assign({}, state, {
        token: action.token,
      });
    }

    case "GLOBAL/CARGAR_USUARIOS_CONTRALORIA": {
      const usuariosContraloria = action.usuariosContraloria;
      let usuariosContraloriavector = "";

      usuariosContraloria.forEach((element) => {
        usuariosContraloriavector += `${element.Nombre},`;
      });

      return Object.assign({}, state, {
        listaUsuariosContraloria: usuariosContraloriavector.slice(0, -1),
      });
    }

    case "GLOBAL/CARGAR_USUARIOS_CONVENIO": {
      const usuariosConvenio = action.usuariosConvenio;
      let usuariosConveniovector = "";

      usuariosConvenio.forEach((element) => {
        usuariosConveniovector += `${element.Nombre},`;
      });

      return Object.assign({}, state, {
        listaUsuariosConvenio: usuariosConveniovector.slice(0, -1),
      });
    }

    case "CARGAR_DATOS_USUARIO": {
      return Object.assign({}, state, {
        loading: false,
        datosUsuario: action.datosUsuario,
      });
    }

    case "GLOBAL/CARGAR_NOMBRE_INSTITUCION": {
      return Object.assign({}, state, {
        nombreInstitucion: action.nombre,
      });
    }

    default:
      return state;
  }
};

export default globalReducer;



// WEBPACK FOOTER //
// ./src/components/Global/reducer.js